<script lang="ts">
  import type { Recent } from '../lib/recents'

  interface Props {
    onLoadSample: () => void
    recents?: Recent[]
    onOpenRecent?: (source: string) => void
  }
  let { onLoadSample, recents = [], onOpenRecent }: Props = $props()
</script>

<div class="empty">
  <h2>Paste markdown to preview</h2>
  <p>
    Drop a <code>.md</code> file anywhere, or
    <button type="button" class="link" onclick={onLoadSample}>load a sample</button>.
  </p>

  {#if recents.length > 0 && onOpenRecent}
    <div class="recents" aria-label="Recent documents">
      <h3>Recent</h3>
      <ul>
        {#each recents as r (r.id)}
          <li>
            <button type="button" onclick={() => onOpenRecent?.(r.source)}>
              {#if r.pinned}<span class="pin" aria-hidden="true">★</span>{/if}
              <span class="title">{r.title}</span>
            </button>
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</div>

<style>
  .empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-3);
    padding: var(--space-6);
    text-align: center;
    color: var(--text-secondary);
  }
  h2 {
    margin: 0;
    font-size: var(--text-xl);
    font-weight: 600;
    color: var(--text-primary);
  }
  p {
    margin: 0;
    max-width: 28rem;
    line-height: 1.5;
  }
  code {
    font-family: var(--font-mono);
    font-size: 0.9em;
    background: var(--code-bg);
    padding: 0.1em 0.35em;
    border-radius: var(--radius-sm);
  }
  .link {
    appearance: none;
    border: none;
    background: none;
    padding: 0;
    font: inherit;
    color: var(--accent);
    cursor: pointer;
    text-decoration: underline;
  }
  .recents {
    width: 100%;
    max-width: 28rem;
    margin-top: var(--space-4);
    text-align: left;
  }
  .recents h3 {
    margin: 0 0 var(--space-2);
    font-size: var(--text-xs);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-muted);
  }
  .recents ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .recents button {
    width: 100%;
    display: flex;
    align-items: center;
    gap: var(--space-2);
    padding: 8px 12px;
    border: 1px solid transparent;
    border-radius: var(--radius-sm);
    background: transparent;
    font: inherit;
    font-size: var(--text-sm);
    color: var(--text-primary);
    text-align: left;
    cursor: pointer;
  }
  .recents button:hover {
    background: var(--bg-surface);
    border-color: var(--border-subtle);
  }
  .pin {
    color: var(--accent);
    font-size: var(--text-xs);
  }
  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }
</style>
